export enum CriterionSubgroupCode {
    OwnerAge = 'TPVALDAM',
    ExperienceOtherDrivers = 'STAZASKITI',
}
